import { combineReducers } from 'redux';
import { reducer as reducerForm } from 'redux-form';
import storage from 'redux-persist/lib/storage';
import { CLEAR_ALL_DATA } from 'redux/actionTypes/authUser';
import authReducer from './auth';
import authTokenReducer from './authToken';
import quotationsReducer from './quotations';
import departmentsReducer from './departments';
import clientsReducer from './clients';
import testsReducer from './tests';
import subDepartmentsReducer from './subDepartments';

const rootReducer = combineReducers({
  auth: authReducer,
  authToken: authTokenReducer,
  form: reducerForm,
  quotations: quotationsReducer,
  departments: departmentsReducer,
  clients: clientsReducer,
  tests: testsReducer,
  subDepartments: subDepartmentsReducer,
});

const appReducer = (state: any, action: any) => {
  if (action.type === CLEAR_ALL_DATA) {
    Object.keys(state).forEach((key) => {
      storage.removeItem(`persist:${key}`);
    });
    state = undefined;
  }
  return rootReducer(state, action);
};

export default appReducer;
